import { jsx } from 'react/jsx-runtime';
import { styled } from '@mui/material/styles';

const VerticalLine = styled('div') `
  background-color: ${({ theme }) => theme.palette.N60.main};
  width: 1px;
  height: 100%;
`;
const VerticalLineAligner = styled('div') `
  padding-top: 5px;
  padding-bottom: 5px;
  background-color: ${({ theme }) => theme.palette.N40.main};
`;
const VerticalRuler = () => (jsx(VerticalLineAligner, { children: jsx(VerticalLine, {}) }));

export { VerticalRuler };
//# sourceMappingURL=VerticalRuler.js.map
